import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import FormMessage from "componentsv2/form/FormMessage";
import SubTable from "components/MeTable/SubTable";
import DropdownField from "components/MeForm/DropdownField";
import SelectionField from "components/MeForm/SelectionField";
import CheckboxField from "components/MeForm/CheckboxField";
import StdButton from "components/Buttons/StdButton";
import { useWizardStore } from "store/wizardStore";
import mainStore from "store/mainStore";
import proxy from "api/proxy";
import funcs from "tools/functions";
import modelCharge from "./Charge";

const attrs = { level: "wizard" };
const OPTIONS = [
  { id: "all", name: "Todo" },
  { id: "partial", name: "Parcial" },
];

const ModelCharge = modelCharge.ctxView({
  selectable: "multi",
  table_action: [],
});

function WizardBill({ onClose, parentRec, wizardOpen }) {
  const msgForm = useSignal({ type: null, msg: null });
  const charges = useSignal([]);
  const party = useSignal(null);
  const kind = useSignal(null);
  const addGuest = useSignal(false);
  const vehiclePlate = useSignal(false);

  const { record, reload } = mainStore.getState();

  useEffect(() => {
    if (wizardOpen?.value) {
      msgForm.value = { type: null, msg: null };
      charges.value = [];
      party.value = null;
      kind.value = null;
      addGuest.value = false;
      vehiclePlate.value = false;
    }
  }, [wizardOpen?.value]);

  async function handleChangeKind() {
    const folios = Array.from(record.lines.values());
    const foliosIds = folios.map((fo) => fo.id);
    const model = "hotel.folio.charge";
    const domain = [
      ["folio", "in", foliosIds],
      ["invoice_line", "=", null],
    ];
    const fieldsNames = funcs.getViewFields(ModelCharge, "list");
    const { data } = await proxy.search(model, domain, fieldsNames);
    charges.value = data;
  }

  function onClickRow(item) {}

  function searchParty() {
    let targetIds;
    if (parentRec) {
      targetIds = [];
      if (parentRec.party) {
        targetIds.push(parentRec.party.id);
      }
      for (const folio of parentRec.lines.values()) {
        if (folio.main_guest) {
          targetIds.push(folio.main_guest.id);
        }
      }
    }
    return targetIds ? [["id", "in", targetIds]] : [];
  }

  async function doInvoice() {
    const { store, reset } = useWizardStore.getState();
    let foliosIds = [];
    for (const folioId of record.lines.keys()) {
      foliosIds.push(folioId);
    }

    const model = "hotel.booking";
    const method = "create_new_invoice";
    let data = {
      booking_id: record.id,
      folios_ids: foliosIds,
      party_id: store.party,
      add_guest: store.add_guest,
      add_vehicle_plate: store.add_vehicle_plate,
      charges: null,
    };

    if (store.selectedRows) {
      data.charges = Array.from(store.selectedRows.values()).map(
        (row) => row.id,
      );
    }

    try {
      await proxy.methodCall({ model, method, args: [data] });
    } catch (error) {
      console.log("Se produjo un error generando factura ! ", error);
      msgForm.value = {
        type: "error",
        text: error.message,
      };
      return;
    }
    onClose();
    reset();
    reload();
    charges.value = [];
  }

  const fieldParty = {
    name: "party",
    label: "hotel.booking.bill.party",
    level: "wizard",
    type: "many2one",
    model: "party.party",
    required: true,
    recSearch: searchParty,
  };

  const fieldKind = {
    name: "kind",
    label: "hotel.booking.bill.kind",
    type: "selection",
    required: true,
    options: OPTIONS,
    onChange: handleChangeKind,
    dependents: ["charges"],
  };

  const fieldCharges = {
    name: "charges",
    label: "hotel.booking.bill.charges",
    type: "one2many",
    model: "hotel.folio.charge",
    ctxView: ModelCharge,
  };

  const fieldAddGuest = {
    name: "add_guest",
    label: "hotel.booking.bill.add_guest",
    type: "boolean",
  };
  const fieldAddVehiclePlate = {
    name: "add_vehicle_plate",
    label: "hotel.booking.bill.add_vehicle_plate",
    type: "boolean",
  };

  return (
    <div id="hotel-booking-wizard-bill">
      {msgForm.value.type && <FormMessage className="" message={msgForm} />}
      <div className="grid grid-cols-2 gap-x-2">
        <DropdownField field={fieldParty} attrs={attrs} data={party} />
        <SelectionField field={fieldKind} attrs={attrs} data={kind} />
        <CheckboxField field={fieldAddGuest} attrs={attrs} data={addGuest} />
        <CheckboxField
          field={fieldAddVehiclePlate}
          attrs={attrs}
          data={vehiclePlate}
        />
      </div>
      <SubTable
        field={fieldCharges}
        attrs={attrs}
        data={charges}
        onClickRow={onClickRow}
      />
      <StdButton
        style="font-semibold"
        color="amber"
        onClick={doInvoice}
        content="hotel.booking.bill"
      />
    </div>
  );
}

export default WizardBill;
